const calculateSplat = (pressure, pressureCoefficient, properties, settings) => {
  const penForceAlpha = settings.penForceAlphaFunction(pressure);
  const penForceSplatRadius = settings.penForceSplatRadiusSizeFunction(pressure);

  const minAlpha = settings.minAlphaFunction(
    settings.minAlphaAsMedium ? properties.medium : settings.minAlphaAsForce ? penForceAlpha : settings.minAlphaConstantScale
  );
  const maxAlpha = settings.maxAlphaFunction(
    settings.maxAlphaAsMedium ? properties.medium : settings.maxAlphaAsForce ? penForceAlpha : settings.maxAlphaConstantScale
  );

  let alpha = settings.alphaFunction(
    minAlpha,
    maxAlpha,
    settings.alphaAsMedium ? properties.medium : settings.alphaAsForce ? penForceAlpha : settings.alphaConstantScale
  );

  if (properties.useGlobalAlpha) {
    alpha = properties.alpha;
  }

  const enhancedAlpha = alpha * pressureCoefficient;
  const splatVelocityScale = properties.splatVelocityScale * enhancedAlpha;
  const enhancedSplatRadius = properties.splatRadius * penForceSplatRadius;

  const color = [...properties.color];
  color[3] = enhancedAlpha;

  return {
    splatRadius: enhancedSplatRadius,
    color,
    zThreshold: properties.zThreshold,
    splatVelocityScale,
  };
};

export default calculateSplat;
